import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {SkillsCheckerRoutingModule} from './skills-checker-routing.module';
import {SkillsCheckerFormComponent} from './skills-checker-form/skills-checker-form.component';
import {SkillsCheckerDevelopmentComponent} from './skills-checker-development/skills-checker-development.component';
import {SkillsCheckerSummaryComponent} from './skills-checker-summary/skills-checker-summary.component';
import {ComponentsModule} from '../components/components.module';
import {SkillsCardComponent} from './skills-checker-summary/skills-card/skills-card.component';
import {SkillsCheckerTeamComponent} from './skills-checker-team/skills-checker-team.component';
import {TranslateModule} from '@ngx-translate/core';
import {SkillsCheckerDevelopmentPipe} from './skills-checker-development/skills-checker-development.pipe';
import {SkillsCheckerTeamCardComponent} from './skills-checker-team/skills-checker-team-card/skills-checker-team-card.component';
import {NgSelectModule} from "@ng-select/ng-select";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        SkillsCheckerRoutingModule,
        ComponentsModule,
        TranslateModule.forChild(),
        NgSelectModule

    ],
    declarations: [
        SkillsCheckerFormComponent,
        SkillsCheckerDevelopmentComponent,
        SkillsCheckerSummaryComponent,
        SkillsCardComponent,
        SkillsCheckerTeamComponent,
        SkillsCheckerTeamCardComponent,
        SkillsCheckerDevelopmentPipe
    ]
})
export class SkillsCheckerModule {
}
